import { render, staticRenderFns } from "./addCheckup.vue?vue&type=template&id=10b2c130"
import script from "./addCheckup.vue?vue&type=script&lang=js"
export * from "./addCheckup.vue?vue&type=script&lang=js"
import style0 from "./addCheckup.vue?vue&type=style&index=0&id=10b2c130&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports